import { useEffect, useState } from "react";
import { IconButton, Tooltip, Zoom, Card } from "@mui/material";
import { Error, Delete, Edit } from "@mui/icons-material";
import DashboardLayout from "../../../Layouts/Layoutcontainers";
import Adduser from "./Adduser";
import EnhancedTable from "../../../components/BTTable";
import BTButton from "../../../components/BTButton";
import BTBox from "../../../components/BTBox";
import ConfirmBox from "../../../components/ConfirmBox";
import authService from "../../../services/auth-service";
import { roles } from "../../../dropdownData";
import { useLoading, useNotification } from "../../../context";
import { get_users } from "../../../store/functions";
import { useSelector } from "react-redux";
const Users = () => {
  const [open, setOpen] = useState(null);
  const [isDelete, setDelete] = useState(null);
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();
  const users = useSelector((state) => state?.lab?.users);
  const CardHeader = () => {
    return (
      <Card sx={{ mb: 1 }}>
        <BTBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          pt={2}
          pb={2}
          px={3}
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BTButton
            variant="gradient"
            size="small"
            color="dark"
            onClick={() => setOpen({ show: true, actionType: 1 })}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            Add user
          </BTButton>
        </BTBox>
      </Card>
    );
  };
  const RenderMenu = ({ row }) => {
    return (
      <BTBox>
        <Tooltip title="Edit" TransitionComponent={Zoom}>
          <IconButton
            size="small"
            onClick={() => {
              setOpen({
                actionType: 2,
                show: true,
                value: row,
              });
            }}
          >
            <Edit fontSize="13px" color="warning" />
          </IconButton>
        </Tooltip>
        <Tooltip title={"Delete"} TransitionComponent={Zoom}>
          <IconButton
            size="small"
            onClick={() => {
              setDelete(row);
            }}
          >
            <Delete fontSize="13px" color="error" />
          </IconButton>
        </Tooltip>
      </BTBox>
    );
  };
  const compactStyles = {
    headerCellStyle: {
      padding: "8px",
      fontSize: "12px",
    },
    bodyCellStyle: {
      padding: "6px",
      fontSize: "12px",
    },
    headerRowStyle: {
      height: "20px",
    },
    bodyRowStyle: {
      height: "20px",
    },
  };
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "0.1rem",
      numeric: false,
      sortable: true,
    },
    {
      id: "first_name",
      name: "First Name",
      cell: (row) => row?.first_name,
      sortable: true,
      numeric: false,
      width: "150px",
    },
    {
      id: "middle_name",
      name: "Middle Name",
      numeric: false,
      selector: (row) => row?.middle_name,
      sortable: false,
      width: "150px",
    },
    {
      id: "last_name",
      name: "Last Name",
      selector: (row) => row?.last_name,
      numeric: false,
      sortable: true,
      width: "150px",
    },
    {
      id: "u_type",
      name: "Role",
      selector: (row) =>
        roles?.find(({ value }) => value === row?.u_type)?.label,
      sortable: true,
      numeric: false,
      width: "150px",
    },
    {
      id: "u_email",
      name: "Email",
      selector: (row) => row?.u_email,
      numeric: false,
      sortable: true,
      width: "150px",
    },
    {
      id: "u_desc",
      name: "Description ",
      selector: (row) => row?.u_desc,
      numeric: false,
      sortable: false,
      width: "150px",
    },

    {
      id: "actions",
      name: "Actions",
      cell: (row) => <RenderMenu row={row} />,
      width: "80px",
      bodyCellStyle: {
        padding: "0px",
      },
      center: true,
    },
  ];
  const getUsers = async () => {
    showLoading();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const response = await get_users();
    if (!response?.status) {
      addNotification({
        message: response?.message?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    }
    hideLoading();
  };
  useEffect(() => {
    !users?.is_fetch && getUsers();
  }, []);
  return (
    <DashboardLayout>
      <CardHeader />
      <EnhancedTable
        tableHeader={true}
        rows={users?.data}
        columns={columns}
        title="Users"
        defaultSort="carbs"
        pagination={true}
        compactStyles={compactStyles}
      />
      {Boolean(open) && <Adduser open={open} setOpen={setOpen} />}
      {Boolean(isDelete) && (
        <ConfirmBox
          row={isDelete}
          setDelete={setDelete}
          service={authService?.delete_user}
          id={"u_id"}
          name={"users"}
        />
      )}
    </DashboardLayout>
  );
};
export default Users;
